import React, { useState } from 'react'

const Subscribe = () => {
  const [inputValue,setInputValue] = useState("")
  const Mailto = (e) => {
    e.preventDefault()
    window.open('mailto:info@vishwanathbuilders.com?subject=${encodeURIComponent("Contact Vishwanath Builders")}}')
  };
  const handleChangeInput = (e) =>{
    setInputValue(e.target.value)
  }
  return (
    <div className="subscribe-container" id="subscribe">
        {/* <p>Contact Us</p> */}
        {/* <input value={inputValue} onChange={handleChangeInput} placeholder='Enter Your Email'/> */}
        <button onClick={Mailto}>CONTACT US</button>
    </div>
  )
}

export default Subscribe